import React from "react";
import * as util from "../../utils/helpers";

/**
 * @module PastActivityEbombsListViewModule
 */
/**
 * this component is used to display the ebombs  in the past activities
 * @param {object} pastActivitiesData contains information related to the ebombs
 */
const PastActivityEbombsListView = (props) => {
  const { pastActivitiesData } = props;

  /**
   * this function renders the toggle part of the ebombs  in past activities
   * @function
   * @inner
   * @memberof module:PastActivityEbombsListViewModule
   * @param {object} item contains information related to the ebombs
   * @returns {JSX.Element}
   */
  const toggle = (item) => {
    return (
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center"
            style={{ marginRight: "2px" }}
          >
            {util.getIconByEvent(pastActivitiesData.typeTitle)}
            <span style={{ fontSize: "12px", display: "d-flex" }}>
              {pastActivitiesData.typeTitle}:
            </span>
          </div>
          {util.get5WordsForTitle(item.subject)}
        </div>
        <div className="d-flex align-items-center  toggle-date-time">
          {util.formatActivityDate(item.datetime)}
        </div>
      </div>
    );
  };

  /**
   * this function renders the collapse part of the ebombs  in past activities
   * @function
   * @inner
   * @memberof module:PastActivityEbombsListViewModule
   * @param {object} item contains information related to the ebombs
   * @returns {JSX.Element}
   */
  const collapse = (item) => {
    return (
      <div className="accordion-body-inner">
        <div className="d-flex align-items-center text-muted mb-1">
          <span className="small mr-2">SUBJECT:</span>{" "}
          <span className="small">{item.subject}</span>
        </div>
        <div className="d-flex align-items-center text-muted mb-1">
          <span className="small mr-2">ADDRESS:</span>{" "}
          <span className="small">{item.email_addresses.toString()}</span>
        </div>
        <div className="d-flex align-items-center text-muted mb-1">
          <span className="small mr-2">FROM:</span>{" "}
          <span className="small">{item.email_from}</span>
        </div>
        <div className="d-flex align-items-center text-muted mb-1">
          <span className="small mr-2">DATE:</span>{" "}
          <span className="small">
            {util.formatActivityDate(item.datetime)}
          </span>
        </div>
        <hr className="light" />
        <div>
          CONTENT URL:{" "}
          <a href={item.content_url} target="_blank" rel="noopener noreferrer">
            {item.content_url}
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="notes-card">
      {props.render(
        toggle(pastActivitiesData.email),
        collapse(pastActivitiesData.email)
      )}
    </div>
  );
};

export default PastActivityEbombsListView;
